import { LinkArticleDetail } from '@/components/links/article'
import { Article } from '@/entities/article'
import { cn, formatDate } from '@utils'
import Image from 'next/image'

export default function RecommendCard({
  small = false,
  data,
}: {
  small?: boolean
  data: Article
}) {
  return (
    <LinkArticleDetail
      slug={data.slug}
      className={cn(
        'relative block w-full overflow-hidden group',
        small ? 'max-h-55' : 'max-h-117.5'
      )}
      style={{ aspectRatio: small ? '380 / 220' : '790 / 470' }}
      scroll={false}
    >
      <Image
        src={data.coverSrc}
        alt={data.subject}
        width={small ? 380 : 790}
        height={small ? 220 : 470}
        unoptimized
        priority
        className='w-full h-full object-cover transition-transform duration-500 group-hover:scale-110'
      />
      <div className='absolute inset-0 z-1 flex flex-col justify-end'>
        <div className='p-2 sm:p-5 bg-linear-to-b from-black/0 to-black/60'>
          {!small && (
            <div className='text-white/90 flex items-center justify-between'>
              <span>{data.authorName}</span>
              <time dateTime={formatDate(data.publishTime)}>
                {formatDate(data.publishTime, 'DD MMM YYYY')}
              </time>
            </div>
          )}

          <h4
            className={cn(
              'text-white font-bold line-clamp-1 lg:line-clamp-2 mt-2.5',
              small ? 'lg:text-xl' : 'lg:text-2xl'
            )}
          >
            {data.subject}
          </h4>
        </div>
      </div>
    </LinkArticleDetail>
  )
}
